/*
 * bundle-guard.js
 *
 * Enforces bundle integrity in the cart. Two rules:
 *
 *   1. A bundle line whose partner product has been removed from the cart is
 *      swapped to its Base variant (no more discount).
 *   2. A bundle line's quantity is always 1 — any qty > 1 is clamped back down.
 *
 * Bundle lines are identified by two hidden line item properties attached when
 * the turapura-bundle-selector toggle adds them:
 *
 *   _bundle_partner_product  → product ID that must remain in the cart
 *   _bundle_base_variant     → variant ID to fall back to if the partner leaves
 *
 * This guard runs after every cart update and on page load. Both rules apply
 * via /cart/change.js, then the cart drawer re-renders with the corrected lines.
 */

(function () {
  'use strict';

  var BUSY = false;

  function getCartSectionIds() {
    var cartEl = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!cartEl || typeof cartEl.getSectionsToRender !== 'function') return [];
    return cartEl.getSectionsToRender().map(function (s) { return s.section || s.id; });
  }

  function renderCartFromResponse(data) {
    var cartEl = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!cartEl || !data || !data.sections) return;
    try {
      if (typeof cartEl.renderContents === 'function') cartEl.renderContents(data);
    } catch (e) { /* ignore — fall back to letting the next cart-update redraw */ }
  }

  function isBundleLine(item) {
    var props = item.properties || {};
    return !!(props._bundle_partner_product && props._bundle_base_variant);
  }

  /* Returns the first issue that needs fixing, or null. Two issue types:
       { type: 'orphan',   line, baseVariant } — partner product missing → swap to Base
       { type: 'over_qty', line }              — bundle qty > 1          → clamp to 1
     Orphans are checked first because they make over_qty issues moot. */
  function findIssue(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;
    var productsInCart = {};
    for (var i = 0; i < cart.items.length; i++) {
      productsInCart[cart.items[i].product_id] = true;
    }
    for (var j = 0; j < cart.items.length; j++) {
      var it = cart.items[j];
      if (!isBundleLine(it)) continue;
      var partnerId = parseInt(it.properties._bundle_partner_product, 10);
      if (!productsInCart[partnerId]) {
        return {
          type:        'orphan',
          line:        j + 1,
          baseVariant: parseInt(it.properties._bundle_base_variant, 10)
        };
      }
    }
    for (var k = 0; k < cart.items.length; k++) {
      var it2 = cart.items[k];
      if (!isBundleLine(it2)) continue;
      if (it2.quantity > 1) {
        return { type: 'over_qty', line: k + 1 };
      }
    }
    return null;
  }

  function applyFix(issue) {
    var sections = getCartSectionIds();
    var body = {
      line:         issue.line,
      sections:     sections.length ? sections : undefined,
      sections_url: window.location.pathname
    };
    if (issue.type === 'orphan') {
      body.id = issue.baseVariant;
    } else if (issue.type === 'over_qty') {
      body.quantity = 1;
    }
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json();
    });
  }

  function runGuard() {
    if (BUSY) return Promise.resolve();
    BUSY = true;

    return fetch(window.Shopify.routes.root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var issue = findIssue(cart);
        if (!issue) return null;
        return applyFix(issue).then(function (data) {
          renderCartFromResponse(data);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-guard', cartData: data });
          }
          return data;
        });
      })
      .catch(function (err) {
        console.error('[bundle-guard] failed:', err);
      })
      .then(function (result) {
        BUSY = false;
        /* If we just patched one orphan, re-check in case there are more
           (rare, but possible if two partner products were both removed). */
        if (result) return runGuard();
      });
  }

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
        if (evt && evt.source === 'bundle-guard') return;
        runGuard();
      });
    }
    /* Also run on page load in case the cart was mutated in another tab. */
    runGuard();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
